import React, { useContext, useMemo } from "react";
import Heading from "@unum/heading";
import classnames from "classnames";
import { ThemeContext } from "@unum/theme";
import { TwoColumnProps } from "./types";
import styles from "./Hero.module.scss";

const TwoColumn = ({
  title,
  children,
  asset,
  ctas,
  icon: Icon
}: TwoColumnProps) => {
  const imageNode = useMemo(() => {
    if (!React.isValidElement<{ className: string }>(asset)) {
      return asset;
    }
    return React.cloneElement(asset, {
      className: classnames(asset.props.className, "hero__image")
    });
  }, [asset]);
  const { accentColour } = useContext(ThemeContext);

  return (
    <div className={classnames(styles["Hero"], "hero hero-product")}>
      <div className="spring">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <div
              className={classnames(styles["wrapper"], "hero-product__content")}
            >
              {Icon && (
                <span style={{ color: accentColour }}>
                  <Icon className={styles.icon} />
                </span>
              )}
              <Heading
                level={1}
                className="hero__heading--alt hero-product__heading"
              >
                {title}
              </Heading>
              <div className="hero-product__description">
                {children}
                {ctas}
              </div>
            </div>
          </div>
          <div
            className={classnames(
              styles["hero-product-column"],
              "col-xs-12",
              "col-md-6",
              "hero-product__column"
            )}
          >
            <div
              className={classnames(
                styles["image-wrapper"],
                "hero-product__image-wrapper"
              )}
            >
              <div
                className={classnames(
                  styles["image"],
                  "hero__image hero-product__image"
                )}
              >
                {imageNode}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwoColumn;
